import React, {useEffect, useState} from "react";
import axios from "axios";
import Popup from "../../../component/Popup/Popup";
import {Button} from "react-bootstrap";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {ApiUrl} from "../../../auth/authMethods";
import BasicLoader from "../../../component/BasicLoader/BasicLoader";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import {numberWithPoints} from "../../../utils/numberWithPoints";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import OrderManagementInputs from "./OrderManagementInputs";

export default function OrderManagement({item}) {

    const baseUrl = `${ApiUrl}/pedidos/management`

    const [lgShow, setLgShow] = useState(false);
    const [showInputs, setShowInputs] = useState(false);
    const [managements, setManagements] = useState([]);
    const [loadItens, setLoadItens] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    const display = 'Gerenciamneto de contrato';

    const button = <>
        <SupervisorAccountIcon fontSize="medium"/> &nbsp; {display}
    </>;

    const title = "Gerenciamneto de contrato";

    const iconSpan = <>
        <SupervisorAccountIcon fontSize="large" id="icon-svg"/>
        <h3>{title}</h3>
    </>;

    useEffect(() => {
        console.log(loadItens)
        if (loadItens) {
            axios.get(`${baseUrl}/${item.id}`)
                .then(response => {
                    setManagements(response.data);
                })
                .catch(error => {
                    console.error("There was an error fetching the files!", error);
                })
                .finally(() => {
                    setIsLoading(false)
                });
        }
    }, [loadItens, showInputs]);



    const listPapelForAdd = item.participantes
        .filter(papelLeilaoItem => papelLeilaoItem.tipoPapel === "COMPRADOR")
        .filter(
            papelLeilaoItem =>
                managements.filter((management) => management.papelLeilaoId === papelLeilaoItem.id).length === 0
        )
        .map(papelLeilaoItem => ({
            value: papelLeilaoItem.id,
            label: papelLeilaoItem.usuario.participante.nome
        }))

    return <Popup
        buttonText={button}
        title={title}
        iconSpan={iconSpan}
        lgShow={lgShow} setLgShow={setLgShow}
        buttonClass={'dropdown-item'}
    >

        <div style={{width: '80%', margin: '0 10%'}}>
            {listPapelForAdd.length > 0 &&
                <Button className='text-end button-show mb-2'
                        onClick={() => {
                            setShowInputs(prevValue => !prevValue)
                        }}>
                    {showInputs ?
                        <>Cancelar <CloseIcon fontSize="medium"/></> :
                        <>Adicionar <AddIcon fontSize="medium"/></>
                    }
                </Button>
            }

            <div style={{padding: '1% 0 0 0 '}} className={''}>
                <h5>Lote: {item.numero} - {item.evento.nomeEvento}</h5>
            </div>
            <hr/>
            {showInputs && <>
                <OrderManagementInputs
                    baseUrl={baseUrl}
                    setLoadItens={setLoadItens}
                    setShowInputs={setShowInputs}
                    listPapel={listPapelForAdd}
                />
                <hr/>
            </>}

            <TableContainer component={Paper} >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome do Comprador</TableCell>
                            <TableCell>Porcentagem</TableCell>
                            <TableCell>Cobrar por Valor Pago</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(isLoading) ?

                            <tr>
                                <td colSpan={2}>
                                    <BasicLoader message='Buscando dados...' height={10}/>
                                </td>
                            </tr> :
                            <>
                                {managements.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{item.comprador}</TableCell>
                                        <TableCell>{numberWithPoints(item.porcentagem)}%</TableCell>
                                        <TableCell>{item.valorPago ? 'Sim' : 'Não'}</TableCell>
                                    </TableRow>
                                ))}
                            </>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <br/>
        </div>
    </Popup>
}
